<template>
  <div class="min-h-screen grid place-items-center bg-zinc-50 dark:bg-zinc-900 transition-colors">
    <div class="text-center">
      <h1 class="text-6xl font-bold text-brand-700">404</h1>
      <p class="mt-2 text-zinc-600 dark:text-zinc-300">Page not found</p>
      <router-link to="/" class="mt-6 inline-block underline text-brand-700">Back to home</router-link>
    </div>
  </div>
</template>

<script setup></script>
